module.exports = __webpack_public_path__ + "img/Bliks_branco.20fa45d6.png";